import { render, staticRenderFns } from "./edit-assessment.vue?vue&type=template&id=bc9f8252&scoped=true&"
import script from "./edit-assessment.vue?vue&type=script&lang=js&"
export * from "./edit-assessment.vue?vue&type=script&lang=js&"
import style0 from "./edit-assessment.vue?vue&type=style&index=0&id=bc9f8252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9f8252",
  null
  
)

export default component.exports